import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LoaderService {

  private loadingSubject = new BehaviorSubject<boolean>(false);
  loading$ = this.loadingSubject.asObservable();

  constructor() { }

  setLoading(loading: boolean) {
    this.loadingSubject.next(loading);
  }

  getLoading(): boolean {
    return this.loadingSubject.value;
  }
}
